<template lang="pug">
    div
        lessonHeader
        div.lesson-title.upper {{currentStep.params.title}}
        div.separator
        v-layout(row justify-start)
            v-flex(xs12)
                v-card(flat)
                    v-img(height="500px" :src="require(`@/assets/${currentStep.params.largeimage}`)")
                        v-btn.white--text.Infographics-view-expand(color="grey darken-2" @click.prevent="dialog=true")
                            v-icon.pr-2 fas fa-expand
                            span Expandir
                v-spacer.py-2
                div.Infographics-view-text.text-sm-left(v-html="currentStep.params.text") 
        el-button.Infographics-view-button(type="success" @click="prevStep") Regresar
        v-dialog(v-model="dialog" scrollable fullscreen)
          v-card            
            v-btn.white--text.Infographics-view-collapse(color="grey darken-2" @click.prevent="dialog=false")
                v-icon.pr-2 fas fa-compress
                span Cerrar
            v-card-text(style="height: 1088px;")
              img(style='width:100%;' :src="require(`@/assets/${currentStep.params.largeimage}`)")
</template>
<script>
import lessonHeader from "@/components/lesson-header/lesson-header";
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'Infographics-view',
  components:{
	lessonHeader,        
  },
  computed: {
      ...mapGetters(['currentStep', 'currentGroup'])
  },
  methods: {
    ...mapMutations(['setCurrentStep']),
    prevStep() {        
      if(this.currentStep.index > 0) {
        const step = this.currentGroup.steps[this.currentStep.index - 1];  
        step.transition = 'slide-back';
        this.setCurrentStep(step);
      }
    }   
  },
  data() {
        return {            
            dialog: false
        }
    }
}
</script>

<style scoped>
@import 'infographics-view.scss';
</style>
